import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SystemDarkIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M14 8.75H15.25V11C15.25 11.41 15.59 11.75 16 11.75C16.41 11.75 16.75 11.41 16.75 11V8.75H18C18.41 8.75 18.75 8.41 18.75 8C18.75 7.59 18.41 7.25 18 7.25H16.75V5C16.75 4.59 16.41 4.25 16 4.25C15.59 4.25 15.25 4.59 15.25 5V7.25H14C13.59 7.25 13.25 7.59 13.25 8C13.25 8.41 13.59 8.75 14 8.75Z"
        fill={color}
      />
      <path
        d="M22.3301 12.48L21.9301 12.28C21.6101 12.12 21.2201 12.21 21.0001 12.5C19.8701 13.99 17.8101 15.65 14.4801 15.13C13.1501 14.92 11.8401 14.24 10.8101 13.2C9.77006 12.16 9.09006 10.85 8.88006 9.52C8.36006 6.18 10.0201 4.13 11.5101 3C11.8001 2.78 11.8901 2.39 11.7301 2.07L11.5301 1.67C11.3901 1.39 11.0901 1.22 10.7701 1.26C5.13006 1.92 1.04006 6.7 1.26006 12.38C1.35006 18.03 6.40006 22.88 12.0501 22.75C17.5401 22.75 22.1001 18.73 22.7501 13.24C22.7901 12.93 22.6201 12.62 22.3401 12.48H22.3301ZM11.6801 21.24C6.95006 21.15 2.84006 17.04 2.76006 12.32C2.60006 8.04 5.28006 4.35 9.20006 3.12C7.64006 4.94 7.00006 7.24 7.40006 9.76C7.66006 11.4 8.49006 13 9.75006 14.26C11.0101 15.52 12.6101 16.35 14.2501 16.61C16.7801 17 19.0701 16.37 20.8801 14.81C19.6501 18.73 15.9601 21.38 11.6801 21.25V21.24Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SystemDarkIcon.displayName = 'SystemDarkIcon';
